import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20and%20amber%20abstract%20geometric%20pattern%20with%20soft%20flowing%20curves%20and%20gentle%20gradients%2C%20elegant%20and%20sophisticated%20texture%20reminiscent%20of%20official%20document%20paper%20with%20delicate%20watermark%20effect%2C%20creamy%20off-white%20background%20with%20subtle%20gold%20accents%2C%20warm%20ambient%20light%2C%20minimalist%20and%20clean%20composition%2C%20high%20quality%20texture%20detail%2C%20professional%20and%20authoritative%20feel&width=1600&height=900&seq=hero-bg-huangbenzi&orientation=landscape"
        alt="黄本子官方指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <i className="ri-verified-badge-line text-primary-300 text-sm"></i>
          <span className="text-xs md:text-sm text-background-50 font-medium tracking-wide">
            最权威的黄本子专题指南
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          黄本子官方指南
          <br />
          <span className="text-primary-300">你最需要了解的完整解析</span>
        </h1>

        <p className="text-sm md:text-base text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          全面解析黄本子的定义、用途、获取方式及注意事项，帮助每一位用户快速了解黄本子的核心价值，掌握正确使用方法，避免常见误区。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dingyi-yongtu"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始了解
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/changjian-wenti"
            className="w-full sm:w-auto px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium text-sm rounded-lg backdrop-blur-sm border border-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            常见问题
            <i className="ri-question-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}